import axios from 'axios'
import {
    isDingTalk,
    quitPage
} from '@/utils/dingtalk'
import router from '@/router'
import {
    ElMessage,
} from 'element-plus'
//注册axios，设置请求根路径
axios.defaults.baseURL = '/public/index.php'
// 钉钉续签单飞：并发 401 共享同一次续签请求
let renewPromise = null
function renewDingTalkToken() {
    if (!renewPromise) {
        const jurisdiction = JSON.parse(window.localStorage.getItem('jurisdiction'))
        renewPromise = axios({
            method: 'post',
            url: 'dlogin',
            data: {
                corpId: '',
                uid: jurisdiction ? jurisdiction.uid : '',
                upup: false,
            },
        }).then(res => {
            if (!res || !res.token) {
                // 续签未拿到新令牌（如账号被移除），交给外层降级
                throw new Error('续签未返回令牌')
            }
            // 续签返回新令牌，必须落盘，否则重试仍带旧令牌
            window.localStorage.setItem('token', res.token)
            window.localStorage.setItem('jurisdiction', JSON.stringify(res.jurisdiction))
            window.localStorage.setItem('route', JSON.stringify(res.route))
        }).finally(() => {
            renewPromise = null
        })
    }
    return renewPromise
}
//请求拦截器 挂在令牌到请求头
axios.interceptors.request.use(config => {
    config.headers.Authorization = window.localStorage.getItem('token')
    config.headers.Fingerprint = window.localStorage.getItem('fingerprint')
    let jurisdiction = JSON.parse(window.localStorage.getItem('jurisdiction'))
    if (jurisdiction && config.data && typeof config.data === 'object') {
        jurisdiction.postvalue = window.localStorage.getItem('postvalue')
        config.data.jurisdiction = jurisdiction //用户权限
    }
    return config
})
//响应拦截器
axios.interceptors.response.use(response => {
    if (response.status != 200) {
        ElMessage({
            type: "warning",
            message: `请求出错,错误代码：${response.status}`,
        })
        return {
            data: []
        };
    }
    switch (response.data.code) {
        case 200:
            return response.data.data
        case 709:
            window.sessionStorage.clear()
            window.localStorage.clear()
            window.location.reload()
            if (isDingTalk()) {
                quitPage()
            }
            console.log('关闭页面')
            break;
        case 401: {
            if (isDingTalk()) {
                // 钉钉内：续签换新令牌后自动重发原请求，无需用户刷新
                if (response.config._renewRetried) {
                    ElMessage({
                        type: "warning",
                        message: '登录状态异常,请重新打开应用',
                    })
                    return {
                        data: []
                    };
                }
                return renewDingTalkToken()
                    .then(() => {
                        // response.config.data 已被序列化为字符串，还原成对象
                        // 请求拦截器才能重新注入最新 jurisdiction
                        const retryConfig = {
                            ...response.config,
                            _renewRetried: true,
                        }
                        if (typeof retryConfig.data === 'string') {
                            try {
                                retryConfig.data = JSON.parse(retryConfig.data)
                            } catch (e) {}
                        }
                        return axios(retryConfig)
                    })
                    .catch(() => {
                        ElMessage({
                            type: "warning",
                            message: '续签失败,请重新打开应用',
                        })
                        return {
                            data: []
                        };
                    })
            } else {
                // 浏览器端:清空缓存后刷新,URL hash 仍保留原路由,
                // 路由守卫会自动带上 redirect 参数跳转到登录页
                window.sessionStorage.clear()
                window.localStorage.clear()
                window.location.reload()
                ElMessage({
                    type: "warning",
                    message: '令牌过期',
                })
            }
            break;
        }
        default:
            ElMessage({
                type: "warning",
                message: response,
            })
            return {
                data: []
            };
    }
}, err => {
    return Promise.reject(err)
})
//导出请求
export default axios